module.exports = __webpack_public_path__ + "img/yszc-gszc-cm.f99c140f.png";